import { getFileUrl } from '@/app/(main)/gallery/utils/getFileUrl';

export const getFilePath = (url?: string | null): string => {
  if (!url) return '/images/no-image.png';
  const pattern = /^(https?:)?\/\//i;
  if (pattern.test(url)) {
    return url;
  }
  return getFileUrl(url) ?? '';
};